"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderLink = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const HeaderLink = props => {
  var _item$headerElement$s, _item$headerElement$s2;
  const {
    item,
    toggleMobileNav,
    t,
    navVisible,
    soldOut,
    ticketsSoon
  } = props;
  const className = "con-text__large-medium con-text".concat(item.headerType === "link" || navVisible ? "__link" : "__button con-text__button" + item.headerElement.class);
  const resolved = (0, _reactRouterDom.useResolvedPath)(item.headerElement.url);
  const match = (0, _reactRouterDom.useMatch)({
    path: resolved.pathname,
    end: true
  });
  const isActive = !!match;
  return ((_item$headerElement$s = item.headerElement.source) === null || _item$headerElement$s === void 0 ? void 0 : _item$headerElement$s.toLowerCase()) === "external" ? /*#__PURE__*/_react.default.createElement("div", {
    className: "additional-button-border"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: className,
    disabled: soldOut,
    onClick: () => {
      window.open(item.headerElement.url, "_blank", "noopener,noreferrer");
    },
    key: t(item.headerElement.text)
  }, ticketsSoon ? t(item.headerElement.text) + t("Pages.Home.TicketsSoon") : soldOut ? t(item.headerElement.text) + t("Pages.Home.TicketsSoldOut") : t(item.headerElement.text))) : ((_item$headerElement$s2 = item.headerElement.source) === null || _item$headerElement$s2 === void 0 ? void 0 : _item$headerElement$s2.toLowerCase()) === "internal" ? item.headerType === "button" ? /*#__PURE__*/_react.default.createElement("div", {
    className: "additional-button-border"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: window.location.pathname === t(item.headerElement.url) && item.headerType === "button" || window.location.pathname === t(item.headerElement.url) && navVisible ? className + " con-text__link-active" : className,
    disabled: false,
    onClick: () => window.location.href = item.headerElement.url,
    key: t(item.headerElement.text)
  }, t(item.headerElement.text))) : /*#__PURE__*/_react.default.createElement("div", {
    className: isActive && item.headerType === "link" || isActive && navVisible ? "con-navlink con-navlink__active" : "con-navlink",
    "data-text": t(item.headerElement.text)
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
    to: item.headerElement.url,
    onClick: toggleMobileNav,
    className: isActive && item.headerType === "link" || isActive && navVisible ? className + "-active link-styles__3 link-styles__3--navbar-links" : className + " link-styles__3"
  }, t(item.headerElement.text))) : console.error("invalid headerType");
};
exports.HeaderLink = HeaderLink;
HeaderLink.propTypes = {
  t: _propTypes.default.func,
  item: _propTypes.default.object,
  toggleMobileNav: _propTypes.default.func,
  soldOut: _propTypes.default.bool,
  ticketsSoon: _propTypes.default.bool
};